import React, { createContext, useState, useEffect } from 'react';
import { Language } from '../types/language';
import { getLanguage, setLanguage } from '../utils/languageStorage';
import { translations } from '../locales';

interface LanguageContextType {
  language: Language;
  changeLanguage: (lang: Language) => void;
  t: (key: string) => string;
}

export const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [language, setLanguageState] = useState<Language>(getLanguage());

  useEffect(() => {
    const saved = getLanguage();
    if (saved) {
      setLanguageState(saved);
    }
  }, []);

  const changeLanguage = (lang: Language) => {
    setLanguageState(lang);
    setLanguage(lang);
  };

  const t = (key: string): string => {
    if (language === 'en') return key;
    const langDict = translations[language];
    if (langDict && langDict[key]) {
      return langDict[key];
    }
    return key; // Fallback to English (the key itself)
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
